import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/Home';
import registerServiceWorker from './registerServiceWorker';
import {pink, blue, lightBlue, blueGrey, indigo, } from 'material-ui/colors';
import { MuiThemeProvider, createMuiTheme, withTheme } from 'material-ui/styles';

const primaryColor = blue;
const secondaryColor = pink;

const defaultTheme = createMuiTheme()
const theme = createMuiTheme({
  palette: {
    contrastThreshold: 3.1,
    tonalOffset: 0.07,
    primary: {
      type: primaryColor,
      light: primaryColor[300],
      main: primaryColor[500],
			main1: primaryColor[600],
			main2: primaryColor[700],
			main3: primaryColor[800],
			main4: primaryColor[900],
      dark: primaryColor[700],
      contrastText: defaultTheme.palette.getContrastText(primaryColor[500]),
    },
    secondary: {
      type: secondaryColor,
      light: secondaryColor.A200,
      main: secondaryColor.A400,
      dark: secondaryColor.A700,
      contrastText: defaultTheme.palette.getContrastText(secondaryColor.A400),
    },
  }
});


ReactDOM.render(<MuiThemeProvider theme={theme}>
<App /></MuiThemeProvider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js